<template>
  <div style="padding:10px;">
    <div v-if="!hasData">
      <NoData msg="亲,您还没有优惠券"/>
    </div>
    <div v-if="hasData">
      <ItemCoupon
        :couponData="items"
        tp="mycoupon"
        v-for="(items,index) in list"
        :key="index"
      ></ItemCoupon>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import ItemCoupon from "@/components/ItemCoupon.vue";
import { MyCoupon } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { Tab, Tabs } from "vant";
import Vue from "vue";
Vue.use(Tab).use(Tabs);
export default {
  components: {
    NoData,
    ItemCoupon
  },
  props: ["active"],
  data() {
    return {
      hasData: false,
      list: []
    };
  },
  created() {
    let txt = "";
    switch (this.active) {
      case "0":
        txt = "not_use";
        break;
      case "1":
        txt = "is_use";
        break;
      case "2":
        txt = "is_expire";
        break;
    }
    MyCoupon(txt, getLocalStorage("login_token")).then(res => {
      if(res.data.list.length>0){
        this.hasData=true;
      }
      this.list = res.data.list;
    });
  },
  activated() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
</style>